import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9113e32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "detail",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "员工姓名", -1))
const _hoisted_3 = { style: {"width":"35%"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "手机号码", -1))
const _hoisted_5 = { style: {"width":"35%"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "公司", -1))
const _hoisted_7 = { style: {"width":"35%"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单状态", -1))
const _hoisted_9 = { style: {"width":"35%"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "支付时间", -1))
const _hoisted_11 = { style: {"width":"35%"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "下单时间", -1))
const _hoisted_13 = { style: {"width":"35%"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单编号", -1))
const _hoisted_15 = { style: {"width":"35%"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "油站类别", -1))
const _hoisted_17 = { style: {"width":"35%"} }
const _hoisted_18 = { class: "detail fixWidth" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "订单总金额", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "优惠金额", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "服务费金额", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "企业实付金额", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "员工三方支付金额", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "国标价", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "油站价", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "企业价", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "加油升数(L)", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "加油重量(KG)", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "支付方式", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "手续费", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "扣减额度", -1))
const _hoisted_32 = { class: "td_item" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "企业卡优惠", -1))
const _hoisted_35 = { class: "td_item" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "员工折扣卡优惠" }, "员工折扣卡优惠", -1))
const _hoisted_38 = { class: "td_item" }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "三方卡券抵扣金额" }, "三方卡券抵扣金额", -1))
const _hoisted_41 = { class: "td_item" }
const _hoisted_42 = { key: 3 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "员工折扣卡卡号" }, "员工折扣卡卡号", -1))
const _hoisted_44 = { class: "td_item" }
const _hoisted_45 = { key: 4 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "汇元预付卡卡号" }, "汇元预付卡卡号", -1))
const _hoisted_47 = { class: "td_item" }
const _hoisted_48 = { class: "detail fixWidth" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "车牌号码", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "车辆品牌", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "车辆颜色", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "车辆验证", -1))
const _hoisted_53 = { class: "detail fixWidth" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "油站名称", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "地区", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "---", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "能源类型", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "油号", -1))
const _hoisted_59 = { class: "detail fixWidth" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("caption", null, null, -1))
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th")
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "已开发票", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "可开票总金额", -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "已开金额", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "未开金额", -1))
const _hoisted_66 = {
  class: "detail",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "员工姓名", -1))
const _hoisted_68 = { style: {"width":"35%"} }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "手机号码", -1))
const _hoisted_70 = { style: {"width":"35%"} }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "公司", -1))
const _hoisted_72 = { style: {"width":"35%"} }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单状态", -1))
const _hoisted_74 = { style: {"width":"35%"} }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "支付时间", -1))
const _hoisted_76 = { style: {"width":"35%"} }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "下单时间", -1))
const _hoisted_78 = { style: {"width":"35%"} }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单编号", -1))
const _hoisted_80 = { style: {"width":"90%","text-align":"left","padding-left":"22px"} }
const _hoisted_81 = { class: "detail" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "车牌号码", -1))
const _hoisted_83 = { style: {"width":"90%","text-align":"left","padding-left":"22px"} }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "车辆唯一识别代码", -1))
const _hoisted_85 = { style: {"width":"90%","text-align":"left","padding-left":"22px"} }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "车辆类型", -1))
const _hoisted_87 = { style: {"width":"25%"} }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "充电验证", -1))
const _hoisted_89 = { style: {"width":"35%"} }
const _hoisted_90 = { class: "detail" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "订单总金额", -1))
const _hoisted_92 = { style: {"width":"25%"} }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "累计充电量", -1))
const _hoisted_94 = { style: {"width":"25%"} }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "电费金额", -1))
const _hoisted_96 = { style: {"width":"25%"} }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "服务费金额", -1))
const _hoisted_98 = { style: {"width":"25%"} }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "订单服务费", -1))
const _hoisted_100 = { style: {"width":"25%"} }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "扣减额度", -1))
const _hoisted_102 = { style: {"width":"25%"} }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "占桩费", -1))
const _hoisted_104 = { style: {"width":"25%"} }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "超时占位费", -1))
const _hoisted_106 = { style: {"width":"25%"} }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "企业卡优惠", -1))
const _hoisted_108 = { style: {"width":"25%"} }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "最终实付", -1))
const _hoisted_110 = { style: {"width":"25%"} }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "支付方式", -1))
const _hoisted_112 = { style: {"width":"70%","text-align":"left","padding-left":"22px"} }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"30%"} }, "关联超时占位费订单号", -1))
const _hoisted_114 = { style: {"width":"70%","text-align":"left","padding-left":"22px"} }
const _hoisted_115 = { class: "detail fixTableWidth" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"80%"} }, "计费时段"),
  /*#__PURE__*/_createElementVNode("td", null, "电费（元/度）"),
  /*#__PURE__*/_createElementVNode("td", null, "服务费（元/度）")
], -1))
const _hoisted_117 = { style: {"width":"80%"} }
const _hoisted_118 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_119 = { class: "detail fixWidth" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "站点名称", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "运营商名称", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "站点城市", -1))
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "站点地址", -1))
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "充电桩设备类型", -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "充电桩编号", -1))
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "充电枪编号", -1))
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "开始充电时间", -1))
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "结束充电时间", -1))
const _hoisted_129 = {
  class: "detail",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "员工姓名", -1))
const _hoisted_131 = { style: {"width":"35%"} }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "手机号码", -1))
const _hoisted_133 = { style: {"width":"35%"} }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "公司", -1))
const _hoisted_135 = { style: {"width":"35%"} }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单状态", -1))
const _hoisted_137 = { style: {"width":"35%"} }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "支付时间", -1))
const _hoisted_139 = { style: {"width":"35%"} }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "下单时间", -1))
const _hoisted_141 = { style: {"width":"35%"} }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单编号", -1))
const _hoisted_143 = { style: {"width":"35%"} }
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "关联充电订单", -1))
const _hoisted_145 = { style: {"width":"35%"} }
const _hoisted_146 = { class: "detail fixWidth" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "实付金额", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "支付方式", -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "总占用时长", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "非充电时长", -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "限时免费时长", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "超时占用时长", -1))
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "总减免时长", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "最终占用时长", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "占位费", -1))
const _hoisted_156 = { class: "detail fixPrechWidth" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { style: {"width":"80%"} }, "计费时段"),
  /*#__PURE__*/_createElementVNode("td", null, "单价（元/分钟）")
], -1))
const _hoisted_158 = { style: {"width":"80%"} }
const _hoisted_159 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_160 = { class: "detail fixWidth" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "站点名称", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "运营商名称", -1))
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "站点城市", -1))
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "站点地址", -1))
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "充电桩设备类型", -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "充电桩编号", -1))
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "充电枪编号", -1))
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "开始充电时间", -1))
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "结束充电时间", -1))
const _hoisted_170 = {
  class: "detail",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单编号", -1))
const _hoisted_172 = { style: {"width":"35%"} }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单状态", -1))
const _hoisted_174 = { style: {"width":"35%"} }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "企业名称", -1))
const _hoisted_176 = { style: {"width":"35%"} }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "员工姓名", -1))
const _hoisted_178 = { style: {"width":"35%"} }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "手机号码", -1))
const _hoisted_180 = { style: {"width":"35%"} }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "下单时间", -1))
const _hoisted_182 = { style: {"width":"35%"} }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "支付时间", -1))
const _hoisted_184 = { style: {"width":"90%","text-align":"left","padding-left":"22px"} }
const _hoisted_185 = {
  class: "detail",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "商品ID", -1))
const _hoisted_187 = { style: {"width":"35%"} }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "商品名称", -1))
const _hoisted_189 = { style: {"width":"35%"} }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "门店名称", -1))
const _hoisted_191 = { style: {"width":"35%"} }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "商品价格", -1))
const _hoisted_193 = { style: {"width":"35%"} }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "订单金额", -1))
const _hoisted_195 = { style: {"width":"90%","text-align":"left","padding-left":"22px"} }
const _hoisted_196 = {
  class: "detail",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"width":"20%"} }, "核销码状态", -1))
const _hoisted_198 = { style: {"width":"35%"} }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"width":"20%"},
  title: "核销码核销时间"
}, "核销码核销时间", -1))
const _hoisted_200 = { style: {"width":"35%"} }
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  style: {"width":"20%"},
  title: "核销码过期时间"
}, "核销码过期时间", -1))
const _hoisted_202 = { style: {"width":"90%","text-align":"left","padding-left":"22px"} }
const _hoisted_203 = { class: "detail fixWidth" }
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "支付方式", -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "订单金额", -1))
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "优惠金额", -1))
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "企业实付金额", -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "员工三方支付金额", -1))
const _hoisted_209 = { class: "td_item" }
const _hoisted_210 = { key: 0 }
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "员工折扣卡优惠" }, "员工折扣卡优惠", -1))
const _hoisted_212 = { class: "td_item" }
const _hoisted_213 = { key: 1 }
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "员工折扣卡卡号" }, "员工折扣卡卡号", -1))
const _hoisted_215 = { class: "td_item" }
const _hoisted_216 = { key: 2 }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "汇元预付卡卡号" }, "汇元预付卡卡号", -1))
const _hoisted_218 = { class: "td_item" }
const _hoisted_219 = { class: "detail fixWidth" }
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "退款原因", -1))
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "申请退款时间", -1))
const _hoisted_222 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "退款成功时间", -1))
const _hoisted_223 = { class: "td_item" }
const _hoisted_224 = { key: 0 }
const _hoisted_225 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "退款失败时间" }, "退款失败时间", -1))
const _hoisted_226 = { class: "td_item" }
const _hoisted_227 = { key: 1 }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { title: "退款失败原因" }, "退款失败原因", -1))
const _hoisted_229 = { class: "td_item" }
const _hoisted_230 = { class: "row_sty" }
const _hoisted_231 = { class: "row_sty" }
const _hoisted_232 = { class: "row_sty" }
const _hoisted_233 = { class: "dis_flex" }
const _hoisted_234 = { class: "detail fixWidth" }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "标记时间", -1))
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "操作人", -1))
const _hoisted_237 = { class: "nick_name" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "标记状态", -1))
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "标记备注", -1))
const _hoisted_240 = ["title"]
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "历史标记记录", -1))
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "标记时间", -1))
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "操作人", -1))
const _hoisted_244 = { class: "nick_name" }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "标记状态", -1))
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "标记备注", -1))
const _hoisted_247 = ["title"]
const _hoisted_248 = ["src"]
const _hoisted_249 = { style: {"padding-bottom":"20px"} }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding":"0 10px"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Remarks = _resolveComponent("Remarks")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_EditRemark = _resolveComponent("EditRemark")!
  const _component_ImageViewer = _resolveComponent("ImageViewer")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_BatchSign = _resolveComponent("BatchSign")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_drawer, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible) = $event)),
      class: "oilOrderDetail",
      width: "700",
      onClose: _ctx.onClose
    }, {
      title: _withCtx(() => [
        _createVNode(_component_router_link, {
          class: "link-goback",
          to: {name: 'order.oil'}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_icon, { type: "arrow-left" })
          ]),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(" 订单详情-" + _toDisplayString(_ctx.label), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          class: "oilOrderDetail__content",
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            (_ctx.type === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_app_section, { title: "订单基本信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_1, [
                        _createElementVNode("tr", null, [
                          _hoisted_2,
                          _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.detailData.orderInfo.userName || '---'), 1),
                          _hoisted_4,
                          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.detailData.orderInfo.phone), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_6,
                          _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.detailData.enterpriseName), 1),
                          _hoisted_8,
                          _createElementVNode("td", _hoisted_9, [
                            _createTextVNode(_toDisplayString(_ctx.detailData.orderInfo.orderStatusStr), 1),
                            (_ctx.detailData.orderInfo.orderStatus === 6)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "link",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refundVisile = true))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("详情")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_10,
                          _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.detailData.orderInfo.payDate), 1),
                          _hoisted_12,
                          _createElementVNode("td", _hoisted_13, _toDisplayString(_ctx.detailData.orderInfo.createDate), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_14,
                          _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.detailData.orderInfo.orderNo), 1),
                          _hoisted_16,
                          _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.detailData.orderInfo.belongTeamDesc), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "支付信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_18, [
                        _createElementVNode("tr", null, [
                          _hoisted_19,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.totalOrderAmount || '---'), 1),
                          _hoisted_20,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.totalDiscountAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_21,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderInfo.serviceFeeAmount), 1),
                          _hoisted_22,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.enterprisePayRealAmount || '---'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_23,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.individualPayRealAmount), 1),
                          _hoisted_24,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.priceofficial), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_25,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.priceGun), 1),
                          _hoisted_26,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.orgPrice), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_27,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.num), 1),
                          _hoisted_28,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.weight), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_29,
                          _createElementVNode("td", null, _toDisplayString(_ctx.orderSourceMap[_ctx.detailData.orderPayInfo.payType] || '---'), 1),
                          _hoisted_30,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderPayInfo.handlingFeeAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_31,
                          _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.detailData.orderInfo.totalUserAmount), 1)
                        ]),
                        (_ctx.isShowPayDiscountAmount !== -1)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                              _hoisted_34,
                              _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.detailData.orderPayInfo.payDiscountAmount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowDiscountCardReduceAmount !== -1)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                              _hoisted_37,
                              _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.detailData.orderInfo.discountCardReduceAmount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowThirdPartyCouponDiscountAmount !== -1)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                              _hoisted_40,
                              _createElementVNode("td", _hoisted_41, _toDisplayString(_ctx.detailData.orderInfo.thirdPartyCouponDiscountAmount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowDiscountCardId !== -1)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_42, [
                              _hoisted_43,
                              _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.detailData.orderInfo.discountCardId || '-'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isShowPrepaidCardCardNos !== -1)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("td", _hoisted_47, _toDisplayString(_ctx.detailData.orderInfo.prepaidCardCardNos || '-'), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.detailData.orderPayInfo.payType === 8 || _ctx.detailData.vehicle?.licensePlate)
                    ? (_openBlock(), _createBlock(_component_app_section, {
                        key: 0,
                        title: "车辆信息"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("table", _hoisted_48, [
                            _createElementVNode("tr", null, [
                              _hoisted_49,
                              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.vehicle.licensePlate || '---'), 1),
                              _hoisted_50,
                              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.vehicle.vehicleBrand), 1)
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_51,
                              _createElementVNode("td", null, _toDisplayString(_ctx.detailData.vehicle.vehicleColour), 1),
                              _hoisted_52,
                              _createElementVNode("td", null, [
                                _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                                  default: _withCtx(() => [
                                    (_ctx.detailData.vehicle.vehicleUrl)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModelOfPic(_ctx.detailData.vehicle.vehicleUrl)))
                                        }, "查看照片"))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode("无")
                                        ], 64))
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_app_section, { title: "油站信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_53, [
                        _createElementVNode("tr", null, [
                          _hoisted_54,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderStationInfo.gasName), 1),
                          _hoisted_55,
                          _hoisted_56
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_57,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderStationInfo.energyType), 1),
                          _hoisted_58,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderStationInfo.oilName), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "发票信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_59, [
                        _hoisted_60,
                        _hoisted_61,
                        _createElementVNode("tr", null, [
                          _hoisted_62,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderInfo.invoiced ? '是' : '否'), 1),
                          _hoisted_63,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderInfo.totalInvoiceAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_64,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderInfo.hasInvoiceAmount), 1),
                          _hoisted_65,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.orderInfo.leftInvoiceAmount), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "备注信息" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        type: "link",
                        class: "remarks_edit",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onEditRemark(_ctx.detailData.orderInfo, 2, 'oil')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Remarks, {
                        "before-pay-remark-json": encodeURIComponent(_ctx.detailData.orderInfo.beforePayRemarkJson),
                        "after-pay-remark-json": encodeURIComponent(_ctx.detailData.orderInfo.afterPayRemarkJson),
                        "payment-remark": _ctx.detailData.orderInfo.paymentRemark
                      }, null, 8, ["before-pay-remark-json", "after-pay-remark-json", "payment-remark"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_app_section, { title: "订单基本信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_66, [
                        _createElementVNode("tr", null, [
                          _hoisted_67,
                          _createElementVNode("td", _hoisted_68, _toDisplayString(_ctx.chargeDetailData.userName || '---'), 1),
                          _hoisted_69,
                          _createElementVNode("td", _hoisted_70, _toDisplayString(_ctx.chargeDetailData.phone), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_71,
                          _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.chargeDetailData.enterpriseName), 1),
                          _hoisted_73,
                          _createElementVNode("td", _hoisted_74, _toDisplayString(_ctx.chargeDetailData.orderStatusDesc), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_75,
                          _createElementVNode("td", _hoisted_76, _toDisplayString(_ctx.formatDate(_ctx.chargeDetailData.payTime)), 1),
                          _hoisted_77,
                          _createElementVNode("td", _hoisted_78, _toDisplayString(_ctx.formatDate(_ctx.chargeDetailData.createDate)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_79,
                          _createElementVNode("td", _hoisted_80, _toDisplayString(_ctx.chargeDetailData.orderNo), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "车辆信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_81, [
                        _createElementVNode("tr", null, [
                          _hoisted_82,
                          _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.chargeDetailData.plateNumber || '---'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_84,
                          _createElementVNode("td", _hoisted_85, _toDisplayString(_ctx.chargeDetailData.vin || '--'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_86,
                          _createElementVNode("td", _hoisted_87, _toDisplayString(_ctx.getCarTypeStr), 1),
                          _hoisted_88,
                          _createElementVNode("td", _hoisted_89, [
                            _createVNode(_component_a_tooltip, { placement: "topLeft" }, {
                              default: _withCtx(() => [
                                (_ctx.chargeDetailData.vehicleUrl)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModelOfPic(_ctx.chargeDetailData.vehicleUrl)))
                                    }, "查看照片"))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("无")
                                    ], 64))
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "支付信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_90, [
                        _createElementVNode("tr", null, [
                          _hoisted_91,
                          _createElementVNode("td", _hoisted_92, _toDisplayString(_ctx.chargeDetailData.totalOrderAmount || '---'), 1),
                          _hoisted_93,
                          _createElementVNode("td", _hoisted_94, _toDisplayString(_ctx.chargeDetailData.chargingDegree), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_95,
                          _createElementVNode("td", _hoisted_96, _toDisplayString(_ctx.chargeDetailData.chargingAmount || '---'), 1),
                          _hoisted_97,
                          _createElementVNode("td", _hoisted_98, _toDisplayString(_ctx.chargeDetailData.serviceAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_99,
                          _createElementVNode("td", _hoisted_100, _toDisplayString(_ctx.chargeDetailData.serviceFeeAmount === null || _ctx.chargeDetailData.serviceFeeAmount === undefined || _ctx.chargeDetailData.serviceFeeAmount === '' ? '---' : (+_ctx.chargeDetailData.serviceFeeAmount).toFixed(2)), 1),
                          _hoisted_101,
                          _createElementVNode("td", _hoisted_102, _toDisplayString(_ctx.chargeDetailData.deductionQuota === null || _ctx.chargeDetailData.deductionQuota === undefined || _ctx.chargeDetailData.deductionQuota === '' ? '---' : (+_ctx.chargeDetailData.deductionQuota).toFixed(2)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_103,
                          _createElementVNode("td", _hoisted_104, _toDisplayString(_ctx.chargeDetailData.occupyAmount), 1),
                          _hoisted_105,
                          _createElementVNode("td", _hoisted_106, _toDisplayString(_ctx.chargeDetailData.occupyTotalOrderAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_107,
                          _createElementVNode("td", _hoisted_108, _toDisplayString(_ctx.chargeDetailData.enterpriseCardAmount ? _ctx.chargeDetailData.enterpriseCardAmount.toFixed(2) : _ctx.chargeDetailData.enterpriseCardAmount), 1),
                          _hoisted_109,
                          _createElementVNode("td", _hoisted_110, _toDisplayString(_ctx.chargeDetailData.payRealAmount ? _ctx.chargeDetailData.payRealAmount.toFixed(2) : _ctx.chargeDetailData.payRealAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_111,
                          _createElementVNode("td", _hoisted_112, [
                            (_ctx.chargeDetailData.payType === 9)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("企业支付（员工）")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.chargeDetailData.payType === 8)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("企业支付（车辆）")
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_113,
                          _createElementVNode("td", _hoisted_114, _toDisplayString(_ctx.chargeDetailData.overtimeOccupyOrderNo), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "充电费明细" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_115, [
                        _hoisted_116,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chargeDetailData.costDetailList, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", _hoisted_117, _toDisplayString(_ctx.formatDate(item.startChargeTime)) + "-" + _toDisplayString(_ctx.formatDate(item.endChargeTime)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.unitPrice), 1),
                            _createElementVNode("td", null, _toDisplayString(item.serviceFeeUnitPrice), 1)
                          ]))
                        }), 128))
                      ]),
                      (_ctx.chargeDetailData.costDetailList && !_ctx.chargeDetailData.costDetailList.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, "暂无数据"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "充电信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_119, [
                        _createElementVNode("tr", null, [
                          _hoisted_120,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.stationName || '---'), 1),
                          _hoisted_121,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.chargingOperatorName || '---'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_122,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.cityName || '---'), 1),
                          _hoisted_123,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.stationAddress || '---'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_124,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.equipmentTypeDesc || '---'), 1),
                          _hoisted_125,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.equipmentId || '---'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_126,
                          _createElementVNode("td", null, _toDisplayString(_ctx.chargeDetailData.connectorId || '---'), 1),
                          _hoisted_127,
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.chargeDetailData.startChargeTime) || '---'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_128,
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.chargeDetailData.endChargeTime) || '---'), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.showRemark(_ctx.chargeDetailData))
                    ? (_openBlock(), _createBlock(_component_app_section, {
                        key: 0,
                        title: "备注信息"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "remarks_edit",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onEditRemark(_ctx.chargeDetailData, 2, 'charge')))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("编辑")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_Remarks, {
                            "before-pay-remark-json": encodeURIComponent(_ctx.chargeDetailData.electricityBeforePayRemarkConfig),
                            "after-pay-remark-json": encodeURIComponent(_ctx.chargeDetailData.electricityAfterPayRemarkConfig),
                            "payment-remark": _ctx.chargeDetailData.paymentRemark || ''
                          }, null, 8, ["before-pay-remark-json", "after-pay-remark-json", "payment-remark"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_app_section, { title: "订单基本信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_129, [
                        _createElementVNode("tr", null, [
                          _hoisted_130,
                          _createElementVNode("td", _hoisted_131, _toDisplayString(_ctx.perchDetailData.userName || '---'), 1),
                          _hoisted_132,
                          _createElementVNode("td", _hoisted_133, _toDisplayString(_ctx.perchDetailData.phone), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_134,
                          _createElementVNode("td", _hoisted_135, _toDisplayString(_ctx.perchDetailData.enterpriseName), 1),
                          _hoisted_136,
                          _createElementVNode("td", _hoisted_137, _toDisplayString(_ctx.perchDetailData.orderStatusDesc), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_138,
                          _createElementVNode("td", _hoisted_139, _toDisplayString(_ctx.formatDate(_ctx.perchDetailData.payTime)), 1),
                          _hoisted_140,
                          _createElementVNode("td", _hoisted_141, _toDisplayString(_ctx.formatDate(_ctx.perchDetailData.createDate)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_142,
                          _createElementVNode("td", _hoisted_143, _toDisplayString(_ctx.perchDetailData.orderNo), 1),
                          _hoisted_144,
                          _createElementVNode("td", _hoisted_145, _toDisplayString(_ctx.perchDetailData.bindElectricityOrderNo), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "占位费信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_146, [
                        _createElementVNode("tr", null, [
                          _hoisted_147,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.totalRealAmount || '---'), 1),
                          _hoisted_148,
                          _createElementVNode("td", null, [
                            (_ctx.perchDetailData.payType === 9)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode("企业支付（员工）")
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.perchDetailData.payType === 8)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode("企业支付（车辆）")
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_149,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.totalOccupyDuration || '---'), 1),
                          _hoisted_150,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.notChargeDuration), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_151,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.timeLimitFreeDuration), 1),
                          _hoisted_152,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.overtimeOccupyDuration), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_153,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.reductionDuration || '---'), 1),
                          _hoisted_154,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.finalOccupyDuration), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_155,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.overtimeOccupyPay || '---'), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "占位费明细" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_156, [
                        _hoisted_157,
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_158, _toDisplayString(_ctx.formatDate(_ctx.perchDetailData.startDate)) + "-" + _toDisplayString(_ctx.formatDate(_ctx.perchDetailData.endDate)), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.unitPrice), 1)
                        ])
                      ]),
                      (_ctx.perchDetailData.costDetailList && !_ctx.perchDetailData.costDetailList.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_159, "暂无数据"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "充电信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_160, [
                        _createElementVNode("tr", null, [
                          _hoisted_161,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.stationName || '---'), 1),
                          _hoisted_162,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.chargingOperatorName), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_163,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.cityName || '---'), 1),
                          _hoisted_164,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.stationAddress), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_165,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.equipmentTypeDesc), 1),
                          _hoisted_166,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.equipmentId), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_167,
                          _createElementVNode("td", null, _toDisplayString(_ctx.perchDetailData.connectorId || '---'), 1),
                          _hoisted_168,
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.perchDetailData.startDate)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_169,
                          _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.perchDetailData.endDate) || '---'), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.type === 4)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_app_section, { title: "订单基本信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_170, [
                        _createElementVNode("tr", null, [
                          _hoisted_171,
                          _createElementVNode("td", _hoisted_172, _toDisplayString(_ctx.detailData.orderNo || '---'), 1),
                          _hoisted_173,
                          _createElementVNode("td", _hoisted_174, _toDisplayString(_ctx.detailData.orderStatusStr), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_175,
                          _createElementVNode("td", _hoisted_176, _toDisplayString(_ctx.detailData.enterpriseName), 1),
                          _hoisted_177,
                          _createElementVNode("td", _hoisted_178, _toDisplayString(_ctx.detailData.userName), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_179,
                          _createElementVNode("td", _hoisted_180, _toDisplayString(_ctx.detailData.phone), 1),
                          _hoisted_181,
                          _createElementVNode("td", _hoisted_182, _toDisplayString(_ctx.detailData.createDate), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_183,
                          _createElementVNode("td", _hoisted_184, _toDisplayString(_ctx.detailData.payTime), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "商品信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_185, [
                        _createElementVNode("tr", null, [
                          _hoisted_186,
                          _createElementVNode("td", _hoisted_187, _toDisplayString(_ctx.detailData.productId || '---'), 1),
                          _hoisted_188,
                          _createElementVNode("td", _hoisted_189, _toDisplayString(_ctx.detailData.productName), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_190,
                          _createElementVNode("td", _hoisted_191, _toDisplayString(_ctx.detailData.storeName), 1),
                          _hoisted_192,
                          _createElementVNode("td", _hoisted_193, _toDisplayString(_ctx.detailData.productPrice), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_194,
                          _createElementVNode("td", _hoisted_195, _toDisplayString(_ctx.detailData.totalOrderAmount), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "核销码信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_196, [
                        _createElementVNode("tr", null, [
                          _hoisted_197,
                          _createElementVNode("td", _hoisted_198, _toDisplayString(_ctx.detailData.verificationStatusStr || '---'), 1),
                          _hoisted_199,
                          _createElementVNode("td", _hoisted_200, _toDisplayString(_ctx.detailData.verificationTime), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_201,
                          _createElementVNode("td", _hoisted_202, _toDisplayString(_ctx.detailData.verificationExpireTime), 1)
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "支付信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_203, [
                        _createElementVNode("tr", null, [
                          _hoisted_204,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.payTypeStr || '---'), 1),
                          _hoisted_205,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.totalOrderAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_206,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.totalDiscountAmount || '---'), 1),
                          _hoisted_207,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.payRealAmount), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_208,
                          _createElementVNode("td", _hoisted_209, _toDisplayString([3, 4].includes(_ctx.detailData.payType) ? _ctx.detailData.payRealAmount : 0), 1)
                        ]),
                        (_ctx.isEmpty(_ctx.detailData.discountCardReduceAmount))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_210, [
                              _hoisted_211,
                              _createElementVNode("td", _hoisted_212, _toDisplayString(_ctx.detailData.discountCardReduceAmount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isEmpty(_ctx.detailData.discountCardId))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_213, [
                              _hoisted_214,
                              _createElementVNode("td", _hoisted_215, _toDisplayString(_ctx.detailData.discountCardId || '-'), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.isEmpty(_ctx.detailData.prepaidCardCardNos))
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_216, [
                              _hoisted_217,
                              _createElementVNode("td", _hoisted_218, _toDisplayString(_ctx.detailData.prepaidCardCardNos || '-'), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_app_section, { title: "退款信息" }, {
                    default: _withCtx(() => [
                      _createElementVNode("table", _hoisted_219, [
                        _createElementVNode("tr", null, [
                          _hoisted_220,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.refundReason || '---'), 1),
                          _hoisted_221,
                          _createElementVNode("td", null, _toDisplayString(_ctx.detailData.refundApplyTime), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_222,
                          _createElementVNode("td", _hoisted_223, _toDisplayString(_ctx.detailData.refundCompletionTime), 1)
                        ]),
                        (_ctx.detailData.refundFailedDate)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_224, [
                              _hoisted_225,
                              _createElementVNode("td", _hoisted_226, _toDisplayString(_ctx.detailData.refundFailedDate), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.detailData.refuseRefundReason)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_227, [
                              _hoisted_228,
                              _createElementVNode("td", _hoisted_229, _toDisplayString(_ctx.detailData.refuseRefundReason), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.orderMarkOpen && _ctx.type !== 4)
              ? (_openBlock(), _createBlock(_component_app_section, {
                  key: 4,
                  title: "订单标记"
                }, {
                  default: _withCtx(() => [
                    (_ctx.marksInfos.exceptionMark === -1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_a_radio_group, {
                            value: _ctx.exceptionMark,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.exceptionMark) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_230, [
                                _createVNode(_component_a_radio, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("标记 正常")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("p", _hoisted_231, [
                                _createVNode(_component_a_radio, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("标记 异常")
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["value"]),
                          _createElementVNode("p", _hoisted_232, [
                            (_ctx.exceptionMark === 1)
                              ? (_openBlock(), _createBlock(_component_a_textarea, {
                                  key: 0,
                                  value: _ctx.reason,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reason) = $event)),
                                  "show-count": "",
                                  maxlength: 120,
                                  placeholder: "请填写备注内容"
                                }, null, 8, ["value"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_233, [
                            _createVNode(_component_a_button, {
                              class: "margin_r",
                              onClick: _ctx.onClose
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("取消")
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _ctx.confirmSubmit
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("确认提交")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_a_button, {
                            type: "link",
                            class: "sign_sty",
                            onClick: _ctx.handleSign
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("标记")
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createElementVNode("table", _hoisted_234, [
                            _createElementVNode("tr", null, [
                              _hoisted_235,
                              _createElementVNode("td", null, _toDisplayString(_ctx.marksInfos.marks[0].createTime), 1),
                              _hoisted_236,
                              _createElementVNode("td", _hoisted_237, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", null, _toDisplayString(_ctx.marksInfos.marks[0].nickName), 1),
                                  _createElementVNode("p", null, _toDisplayString(_ctx.marksInfos.marks[0].mobile ? `(${_ctx.marksInfos.marks[0].mobile})` : ''), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("tr", null, [
                              _hoisted_238,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getExceptionMark), 1),
                              _hoisted_239,
                              _createElementVNode("td", {
                                title: _ctx.marksInfos.marks[0].reason
                              }, _toDisplayString(_ctx.marksInfos.marks[0].reason || '--'), 9, _hoisted_240)
                            ])
                          ]),
                          _hoisted_241,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marksInfos.marks.slice(1), (item, index) => {
                            return (_openBlock(), _createElementBlock("table", {
                              key: index,
                              class: "detail fixWidth"
                            }, [
                              _createElementVNode("tr", null, [
                                _hoisted_242,
                                _createElementVNode("td", null, _toDisplayString(item.createTime), 1),
                                _hoisted_243,
                                _createElementVNode("td", _hoisted_244, [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("p", null, _toDisplayString(item.nickName), 1),
                                    _createElementVNode("p", null, "(" + _toDisplayString(item.mobile) + ")", 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _hoisted_245,
                                _createElementVNode("td", null, _toDisplayString(item.exceptionMark === 1 ? '异常' : '正常'), 1),
                                _hoisted_246,
                                _createElementVNode("td", {
                                  title: item.reason
                                }, _toDisplayString(item.reason || '--'), 9, _hoisted_247)
                              ])
                            ]))
                          }), 128))
                        ], 64))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label-col", "wrapper-col"])
      ]),
      _: 1
    }, 8, ["visible", "onClose"]),
    _createVNode(_component_EditRemark, {
      ref: "editRemarkRef",
      onComplete: _ctx.updateRemark
    }, null, 8, ["onComplete"]),
    _createVNode(_component_ImageViewer, {
      visible: _ctx.remarkPicVisible,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.remarkPicVisible) = $event)),
      "preview-src-list": _ctx.payRemarkImageList
    }, null, 8, ["visible", "preview-src-list"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.modelVisible,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modelVisible) = $event)),
      title: "查看照片",
      width: 640,
      "destroy-on-close": true,
      style: {"top":"20px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: _ctx.autoInParkImg,
          style: {"width":"100%"}
        }, null, 8, _hoisted_248)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_BatchSign, {
      "batch-visible": _ctx.signVisible,
      "sign-type": 1,
      "selected-rows": [_ctx.record.orderNo],
      "order-type": _ctx.type,
      onCloseModal: _ctx.closeModal,
      onOnRefreshTable: _ctx.onClose
    }, null, 8, ["batch-visible", "selected-rows", "order-type", "onCloseModal", "onOnRefreshTable"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.refundVisile,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.refundVisile) = $event)),
      title: "退款金额详情",
      width: "50%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_249, [
            _createTextVNode(" 退款总次数: " + _toDisplayString(_ctx.refundAmountInfo.totalRefundNum || 0), 1),
            _hoisted_250,
            _createTextVNode("退款总金额: " + _toDisplayString(_ctx.refundAmountInfo.refundedAmount || 0), 1)
          ]),
          _createVNode(_component_a_table, {
            "data-source": _ctx.refundAmountInfo.details,
            columns: _ctx.refundColumns,
            bordered: "",
            style: {"width":"100%"}
          }, null, 8, ["data-source", "columns"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}